module.exports = __webpack_public_path__ + "assets/img/609e59a864284acd28ae3a9ec0519efd.svg";